import React from 'react'
import { Card, CardContent } from './ui/card'
import { Button } from './ui/button'
import { cn } from '../lib/utils'

// Reusable empty-state card. Use for "you have no X yet" surfaces.
// Pass `action={{ label, onClick }}` for an orange primary CTA.
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
  iconColorClass = 'text-app-primary-500',
  iconBgClass = 'bg-app-primary-100 dark:bg-app-primary-900/30',
}) {
  return (
    <Card className={className}>
      <CardContent className="py-12 px-6 text-center">
        {Icon && (
          <div className={cn('mx-auto mb-3 inline-flex p-3 rounded-full', iconBgClass)}>
            <Icon className={cn('w-6 h-6', iconColorClass)} />
          </div>
        )}
        {title && (
          <p className="text-sm font-medium text-foreground mb-1">{title}</p>
        )}
        {description && (
          <p className="text-xs text-muted-foreground mb-4 max-w-xs mx-auto">
            {description}
          </p>
        )}
        {action && (
          <Button
            onClick={action.onClick}
            className="bg-app-primary-500 hover:bg-app-primary-600 text-white"
          >
            {action.label}
          </Button>
        )}
      </CardContent>
    </Card>
  )
}
